var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"footer"},[_c('div',{staticClass:"container"},[_c('span',{staticClass:"footer-text"},[_vm._v(" Meu Ateliê v"+_vm._s(_vm.version)+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }